import clsx from 'clsx'
import {Link, useLocation} from 'react-router-dom'
import {useLayout} from '../../../core'
import {usePageData} from '../../../core/PageData'

const PageTitle = ({hideBreadcrumbs = false}: {hideBreadcrumbs?: boolean}) => {
  const {pageTitle, pageDescription, pageBreadcrumbs} = usePageData()
  const {config, classes} = useLayout()
  const location = useLocation()
  const appPageTitleDirection = config.app?.pageTitle?.direction

  // Check if we're on a library page and set title accordingly
  const isLibraryPage = location.pathname.includes('/lib-profile')
  const displayTitle = isLibraryPage ? 'Library Access Setting' : pageTitle

  const normalizedPath = location.pathname.replace(new RegExp(`^${process.env.PUBLIC_URL}`), '').replace(/\/$/, '')
  const showProcessDesignBreadcrumbBelowTitle = normalizedPath === '/design/process/process-list'
  const showLibraryDesignBreadcrumbBelowTitle = normalizedPath === '/design/lib-profile/record-profile-design'
  const showProcessBreadcrumbBelowTitle = normalizedPath === '/process/process-access'

  return (
    <div
      id='kt_page_title'
      data-kt-swapper='true'
      data-kt-swapper-mode='prepend'
      data-kt-swapper-parent="{default: '#kt_content_container', 'lg': '#kt_toolbar_container'}"
      className={clsx(
        'page-title d-flex flex-wrap me-3',
        classes.pageTitle.join(' '),
        config.app?.pageTitle?.class,
        {
          'flex-column justify-content-center': appPageTitleDirection === 'column',
          'align-items-center': appPageTitleDirection !== 'column',
        }
      )}
    >
      {/* begin::Title */}
      {config.app?.pageTitle?.display && displayTitle && (
        <h1
          className={clsx('page-heading d-flex text-dark fw-bold fs-3 my-0', {
            'flex-column justify-content-center': appPageTitleDirection,
            'align-items-center': !appPageTitleDirection,
          })}
        >
          {displayTitle}
          {pageDescription && config.app?.pageTitle && config.app?.pageTitle?.description && (
            <span
              className={clsx('page-desc text-muted fs-7 fw-semibold', {
                'pt-2': appPageTitleDirection === 'column',
              })}
            >
              {config.app?.pageTitle?.direction === 'row' && (
                <span className='h-20px border-1 border-gray-300 border-start ms-3 mx-2'></span>
              )}
              {pageDescription}{' '}
            </span>
          )}
        </h1>
      )}
      {/* end::Title */}

      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        !hideBreadcrumbs &&
        (showProcessDesignBreadcrumbBelowTitle || showLibraryDesignBreadcrumbBelowTitle || showProcessBreadcrumbBelowTitle) && (
          <div className='w-100 mt-2'>
            <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
              {pageBreadcrumbs
                .filter(item => !item.isSeparator)
                .slice(-1)
                .map((item, index) => (
                  <li
                    className={clsx('breadcrumb-item', {
                      'text-dark': item.isActive,
                      'text-muted': !item.isActive,
                    })}
                    key={`${item.path}-${index}`}
                  >
                    {item.isActive ? (
                      <span className='text-dark'>{item.title}</span>
                    ) : item.onClick ? (
                      <button
                        className='btn btn-link p-0 border-0 text-decoration-underline text-primary text-hover-primary fw-semibold fs-7'
                        onClick={item.onClick}
                      >
                        {item.title}
                      </button>
                    ) : (
                      <Link className='text-decoration-underline text-primary text-hover-primary' to={item.path}>
                        {item.title}
                      </Link>
                    )}
                  </li>
                ))}
            </ul>
          </div>
        )}

      {pageBreadcrumbs &&
        pageBreadcrumbs.length > 0 &&
        config.app?.pageTitle &&
        config.app?.pageTitle?.breadCrumb &&
        !hideBreadcrumbs &&
        !showProcessDesignBreadcrumbBelowTitle &&
        !showLibraryDesignBreadcrumbBelowTitle &&
        !showProcessBreadcrumbBelowTitle && (
          <>
            {config.app?.pageTitle?.direction === 'row' && (
              <span className='h-20px border-gray-300 border-start mx-4'></span>
            )}
            <ul className='breadcrumb breadcrumb-separatorless fw-semibold fs-7 my-0'>
              {pageBreadcrumbs
                .filter(item => !item.isSeparator) // Filter out separator items (legacy support)
                .map((item, index) => (
                  <li
                    className={clsx('breadcrumb-item', {
                      'text-dark': item.isActive,
                      'text-muted': !item.isActive,
                    })}
                    key={`${item.path}-${index}`}
                  >
                    {item.isActive ? (
                      <span className='text-dark'>{item.title}</span>
                    ) : item.onClick ? (
                      <button
                        className='btn btn-link p-0 border-0 text-decoration-underline text-primary text-hover-primary fw-semibold fs-7'
                        onClick={item.onClick}
                      >
                        {item.title}
                      </button>
                    ) : (
                      <Link className='text-decoration-underline text-primary text-hover-primary' to={item.path}>
                        {item.title}
                      </Link>
                    )}
                    {index < pageBreadcrumbs.filter(item => !item.isSeparator).length - 1 && (
                      <span className='breadcrumb-separator mx-2'>/</span>
                    )}
                  </li>
                ))}
            </ul>
          </>
        )}
    </div>
  )
}

export {PageTitle}
